import React from 'react';
import './styles/Checkbox.css';

export default class ControlledCheckbox extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      checked: false
    };
  }

  componentDidMount() {
    if (this.props.isChecked) {
      this.setState({ checked: true });
    }
  }

  onChangeHandler = () => {
    const func = this.props.change.bind(this, this.state.checked);
    func();
    this.setState({ checked: !this.state.checked });
  };

  render() {
    return (
      <label className="customCheckbox-container">
        {this.props.label}

        <input
          type="checkbox"
          onChange={this.onChangeHandler}
          checked={this.state.checked}
        />

        <span className="checkmark"></span>
      </label>
    );
  }
}
